/**
** 安全检查条目信息
 */
<template>
  <div id="EntryInformation" class="jc-page">
    <div class="jc-panel jc-page-head">
      <div class="header-title">{{ headerTitle }}</div>
      <div class="header-operation">
        <el-form ref="form" :model="form">
          <el-form-item>
            <el-input
              v-model="form.checkup_item_no"
              placeholder="检查条目编号"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-cascader clearable
              :options="classlistTree"
              props.checkStrictly = true
              :props="classlistTreeProps"
              v-model="form.checkup_category_id"
              placeholder="归属检查分类"
              :show-all-levels="false"></el-cascader>
          </el-form-item>
          <!-- <el-form-item> -->
          <el-button class="button" @click="getTableListInit">查询</el-button>
          <!-- </el-form-item>
                      <el-form-item> -->
          <el-button class="button" @click="deleteTable">删除</el-button>
          <!-- </el-form-item>
                      <el-form-item> -->
          <el-button class="button" @click="addLine"
            >添加</el-button
          >
          <!-- </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="jc-table-container jc-scroll-panel">
      <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <!-- <el-table-column
            type="index"
            label="检查编号"
            width="100"
          ></el-table-column> -->
            <el-table-column label="检查编号" width="100">
            <template slot-scope="scope">{{ scope.row.checkup_item_no }}</template>
          </el-table-column>

          <el-table-column label="检查分类" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_category_name }}</template>
          </el-table-column>

          <el-table-column label="项目" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_name }}</template>
          </el-table-column>

          <el-table-column label="评估内容" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_evaluation_content }}</template>
          </el-table-column>

          <el-table-column label="标准分" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_basic_score }}</template>
          </el-table-column>

          <el-table-column label="评分标准" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_score_point }}</template>
          </el-table-column>

        <el-table-column label="评估方式" width="100"  >
            <template slot-scope="scope" >
  <!-- scope.row.checkup_item_evaluation_origin_list[0].evaluation_method_type_name -->
            <span  v-for="(item,index) in scope.row.checkup_item_evaluation_origin_list" :key="item.key" ><span>{{item.evaluation_method_type_name}}</span>
            <hr   v-if="scope.row.checkup_item_evaluation_origin_list.length!==index+1"/></span>

            </template>
          </el-table-column>

          <el-table-column label="检查要点/支撑材料" min-width="250">
            <template slot-scope="scope">
                <span  v-for="(item,index) in scope.row.checkup_item_evaluation_origin_list" :key="item.evaluation_method_type_id" >
                  <div v-html="formatScaleStandard(item.checkup_item_inspection_point)"></div>
                  <hr   v-if="scope.row.checkup_item_evaluation_origin_list.length!==index+1"/>
                </span>
            </template>
          </el-table-column>

          <el-table-column label="标准化要求" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_standard_require }}</template>
          </el-table-column>

          <el-table-column label="企业达标标准" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_standard_point }}</template>
          </el-table-column>

          <el-table-column label="评审方法" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_review_method }}</template>
          </el-table-column>

          <el-table-column label="评审标准-否却项" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_no_but }}</template>
          </el-table-column>

          <el-table-column label="评审标准-扣分项" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_review_criteria_deduction }}</template>
          </el-table-column>

          <el-table-column label="标准化评审规范号" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_number }}</template>
          </el-table-column>

          <el-table-column label="标准化评审内容" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_standard_review_content }}</template>
          </el-table-column>

          <el-table-column label="检查内容/考核要求" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_content }}</template>
          </el-table-column>

          <el-table-column label="检查依据" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_basis }}</template>
          </el-table-column>

          <el-table-column label="检查方法" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_inspection_method }}</template>
          </el-table-column>

          <el-table-column label="案例照片" min-width="200">
            <template slot-scope="scope">
              <template v-if="scope.row.checkup_item_case_image_list.length > 0">
              <span v-for="(item, index) in scope.row.checkup_item_case_image_list" :key="index">
                <img class="qua-img" :src="item.source" :preview='scope.row.checkup_item_id'>
              </span>
            </template>
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column label="完成时限" min-width="200">
            <template slot-scope="scope">{{ scope.row.checkup_item_complete_time_limit }}</template>
          </el-table-column>


          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                @click="handleEdit(scope.$index, scope.row)"
                type="text"
                size="small"
                >编辑</el-button
              >
              <span>|</span>

              <el-button
                type="text"
                size="small"
                @click="handleDelete(scope.$index, scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="text-align:right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="count"
          layout="total, prev, pager, next"
          :total="total"
          >
        </el-pagination>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="dialog"
       @close="resetForm()"
    >
      <el-form ref="addOrganForm" :model="addOrganForm" status-icon :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="检查编号" prop="checkup_item_no">
              <el-input
                v-model="addOrganForm.checkup_item_no"
                placeholder="请输入检查编号"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="归属检查分类">
              <el-cascader clearable
                :options="classlistTree"
                @change="setCheckup"
                :props="classlistTreeProps"
                v-model="addOrganForm.checkup_category_id"
                placeholder="请选择检查分类"
                :show-all-levels="false"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <h3 style="float: left">检查项目设置</h3>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="项目" prop="checkup_item_name">
              <el-input
                :disabled="selectEntryInformation.checkup_item_name_switch==='0'"
                v-model="addOrganForm.checkup_item_name"
                placeholder="请输入项目"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="scoreFlag != '0'">
            <el-form-item label="选择打分机制" prop="checkup_item_basic_score">
              <el-select v-model="checkup_item_bcadd_bcsub" placeholder="请选择">
                <el-option v-for="item in option" :key="item.checkup_item_bcadd_bcsub" :label="item.label" :value="item.checkup_item_bcadd_bcsub">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8" v-if="scoreFlag != '0'">
            <el-form-item label="标准分" prop="checkup_item_basic_score">
              <el-input
               :disabled="selectEntryInformation.checkup_item_basic_score_switch==='0'"
                v-model="addOrganForm.checkup_item_basic_score"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="评估内容" prop="checkup_item_evaluation_content">
              <el-input
                type="textarea"
                 :disabled="selectEntryInformation.checkup_item_evaluation_content_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入评估内容"
                v-model="addOrganForm.checkup_item_evaluation_content"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="评分标准">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_score_point_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入评分标准"
                v-model="addOrganForm.checkup_item_score_point"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h3 style="float: left">检查要点/支撑材料</h3>
        </el-row>
	<el-text v-if="selectEntryInformation.checkup_item_evaluation_method_switch==='1'" type="danger" size="large" style="color:#ff0000">
			注意：如需使检查条目适用于小程序，必须选中“现场询问”选项卡。
  
	</el-text>
<!-- 评估方式 -->
        <el-row v-if="selectEntryInformation.checkup_item_evaluation_method_switch==='1'">
        <el-form-item label="">
          <el-checkbox-group v-model="addOrganForm.evaluation_method_type_id_list">
            <el-checkbox-button
              label = "1"
            >书面材料</el-checkbox-button>
            <el-checkbox-button
              label = "2"
            >现场询问</el-checkbox-button>
            <el-checkbox-button
              label="3"
            >实地考察</el-checkbox-button>
          </el-checkbox-group>
        </el-form-item>
        </el-row>

        <div v-for="item in addOrganForm.evaluation_method_type_id_list">
          <el-row  v-if="item==='1'">
          <el-col :span="24" >
            <el-form-item class="textareaFrom" label="书面评估-支撑材料">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入支撑材料内容"
                v-model="addOrganForm.checkup_item_inspection_point1"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="item==='2' ">
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="现场询问-支撑材料">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入支撑材料内容"
                v-model="addOrganForm.checkup_item_inspection_point2"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row v-if="item==='3'">
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="实地考察-支撑材料">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入支撑材料内容"
                v-model="addOrganForm.checkup_item_inspection_point3"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
          </div>
          <!-- 如果评估方式为忽略，支撑材料为必填时显示 -->
                  <el-row v-if="selectEntryInformation.checkup_item_evaluation_method_switch==='0'&&selectEntryInformation.checkup_item_inspection_point_switch==='1'">
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="请输入支撑文件内容">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入支撑材料内容"
                v-model="addOrganForm.checkup_item_inspection_point0"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="标准化要求">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_standard_require_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入标准化要求"
                v-model="addOrganForm.checkup_item_standard_require"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="企业达标标准">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_standard_point_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入企业达标标准"
                v-model="addOrganForm.checkup_item_standard_point"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="评审方法">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_review_method_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入评审方法"
                v-model="addOrganForm.checkup_item_review_method"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="评审标准-否却项">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_review_criteria_no_but_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入评审标准-否却项"
                v-model="addOrganForm.checkup_item_review_criteria_no_but"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="评审标准-扣分项">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_review_criteria_deduction_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入评审标准-扣分项"
                v-model="addOrganForm.checkup_item_review_criteria_deduction"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="标准化评审规范号">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_standard_review_number_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入标准化评审规范号"
                v-model="addOrganForm.checkup_item_standard_review_number"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="标准化评审内容">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_standard_review_content_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入标准化评审内容"
                v-model="addOrganForm.checkup_item_standard_review_content"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="检查内容/考核要求">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_inspection_content_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入检查内容/考核要求"
                v-model="addOrganForm.checkup_item_inspection_content"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="检查依据">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_inspection_basis_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入检查依据"
                v-model="addOrganForm.checkup_item_inspection_basis"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="检查方法">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_inspection_method_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入检查方法"
                v-model="addOrganForm.checkup_item_inspection_method"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="案例照片：" prop="checkup_item_case_image_list">
            <el-upload
              ref="upload"
              class="upload-demo"
              multiple
              list-type="picture-card"
              :action="UploadImageUrl()"
              :data="imageUploadParam"
              :on-remove="handleRemove"
              :on-preview="handlePicturePreview"
              :on-success="handleAvatarSuccess"
              :file-list="fileList">
              <i class="el-icon-plus"></i>
            </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item class="textareaFrom" label="完成时限">
              <el-input
                type="textarea"
                :disabled="selectEntryInformation.checkup_item_complete_time_limit_switch==='0'"
                :autosize="{ minRows: 2, maxRows: 4 }"
                placeholder="请输入完成时限"
                v-model="addOrganForm.checkup_item_complete_time_limit"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="resetForm">取消</el-button>
        <el-button type="primary" @click="submitForm"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {getCheckupItemDetail, getCheckupItemList, getCheckupCategoryList, saveCheckupItemInfo, deleteCheckupItemInfo} from '@/apis/entryInformation'
import {getCheckupCategoryTreeList} from '@/apis/classInformation'
import Cookies from 'js-cookie';
import config from '../../../../../config/index';
import {compareVersion} from '../../../../utils/compareVersion';

export default {
  name: "EntryInformation",
  data() {
    return {
      option: [{
        checkup_item_bcadd_bcsub: '1',
        label: '扣分项目'
      }, {
        checkup_item_bcadd_bcsub: '2',
        label: '加分项目'
      }],
      checkup_item_bcadd_bcsub: '1',
      rules: {
        checkup_item_no: [
          {
            validator: (rule, value, callback) => {
              if (!/^([1-9]\d|[1-9])(.([1-9]\d|\d))*$/.test(value)) callback(new Error('检查编号必须为小数点分隔的数字构成'))
              else callback()
            },
            trigger: 'blur'
          }
        ]
      },
      dialogVisible: false,
      currentPage:1,// 当前页数
      count:10,//表格页数
      total:0,
      classlistTree:[],
      classlistTreeProps: {
        label: "checkup_category_name",
        value: "checkup_category_id",
        checkStrictly : true
      },
      headerTitle: "安全检查条目信息",
      dialogTitle:'新增条目信息',
      multipleSelection: [], //选中表格
      dialogVisible: false, //对话框显示标识
      form: {
        checkup_item_no: "",
        checkup_category_id: "",
      },
      imageUploadParam:{
        device_type:10,
        user_id:Cookies.get("user_id"),
        token:Cookies.get("token"),
        jsonText:JSON.stringify({"image_type_key" : "checkup_item_case_image"})
      },
      fileList: [],
      projectOption:[],
      tableData: [], //表格内容
      addOrganForm: {
        checkup_item_id: "0",//检查条目id（0-添加;非0-修改）
        checkup_item_name: "",//检查条目名称
        checkup_item_no: "",//检查条目编号
        checkup_category_id: "",//检查分类id
        checkup_item_basic_score: "0",//标准分
        checkup_item_evaluation_content: "",//评估内容
        checkup_item_score_point: "",//评分标准
        checkup_item_standard_require: "",
        checkup_item_standard_point: "",
        checkup_item_review_method: "",
        checkup_item_review_criteria_no_but: "",
        checkup_item_review_criteria_deduction: "",
        checkup_item_standard_review_number: "",
        checkup_item_standard_review_content: "",
        checkup_item_inspection_content: "",
        checkup_item_inspection_basis: "",
        checkup_item_inspection_method: "",
        checkup_item_case_image_list: [],
        checkup_item_complete_time_limit:"",
        evaluation_method_type_id_list:[],//评估方式数组
        checkup_item_inspection_point_list:[],//发送数组对象
        checkup_item_inspection_point1:"",//对应四项支撑材料，需要遍历evaluation_method_type_id_list数组放入checkup_item_inspection_point_list数组
        checkup_item_inspection_point2:"",
        checkup_item_inspection_point3:"",
        checkup_item_inspection_point0:"",
      }, //机构添加的表单内容
      selectEntryInformation:{},//选择分类数据
      cascaderEntryInformation: [//归属检查分类列表

      ],
      uploadUrl: process.env.BASE_API,
      scoreFlag: "1",
    };
  },
  mounted() {
    this.getTableListInit();
    this.getClassListTree()
  },
  methods: {
    UploadImageUrl: function() {
            return this.uploadUrl + "/Base/Tools/editImage";
        },
    //删除图片
    handleRemove(file, fileList) {
      let vm = this;
      let arr = [];
      fileList.forEach(item => {
        if(vm.addDialogFormVisible) {
          let url = item.response.data.image_info.path
          arr.push(url);
        } else {
          arr.push(item.url);
        }
      })
      vm.fileList = arr;
    },

    //查看照片
    handlePicturePreview(file) {
      console.log(file);
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //图片上传成功
    handleAvatarSuccess(response, file, fileList){
      this.fileList.push(response.data.image_info.path);
    },

    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.getTableListInit();
    },
    getClassListTree(){
      getCheckupCategoryTreeList().then((res) => {
          if (res.data.status === "1") {
            this.classlistTree = res.data.data.checkup_category_tree_list;
          } else {
            this.$message.error(res.data.msg);
          }
        })
      .catch((error) => {});
    },
    formatScaleStandard(data){
      let content = ""
      if(data.indexOf("：") > -1){
        content = data.split("：")[0] + '：<br>'
      }
      if(data.indexOf(":") > -1){
        content = data.split(":")[0] + ':<br>'
      }
      let temp = data.split(/[：:;；]/i)
      let i = content.length > 0 ? 1:0
      for(; i<temp.length; i++){
        content = content + `${temp[i]};<br>`
      }
      return content
    },
    getTableListInit() {//请求基础数据
      getCheckupItemList({
          checkup_item_no: this.form.checkup_item_no,
          checkup_category_id: this.form.checkup_category_id[this.form.checkup_category_id.length-1],
          pagination: {
            page: this.currentPage,
            count: this.count,
          },
        })
        .then((res) => {
          //  if(res.data.data.status===1){
           this.$message.success(res.data.msg);
            this.tableData = res.data.data.checkup_item_list.sort((f, s) => compareVersion(f.checkup_item_no, s.checkup_item_no));
            this.count = res.data.data.paginated.count
            this.total = parseInt(res.data.data.paginated.total)

          // }else{
          //   this.$message.error(res.data.msg);
          // }
        })
        .catch((error) => {});


//获取检查分类
      getCheckupCategoryList({
          checkup_category_name: '',
          checkup_category_no: '',
          checkup_category_parent_id:'',
          pagination: {
            page: 1,
            count: 1000,
          },
        })
        .then((res) => {
          //  if(res.data.data.status===1){
              this.$message.success(res.data.msg);
              this.cascaderEntryInformation = res.data.data.checkup_category_list;
          // }else{
          //   this.$message.error(res.data.msg);
          // }

        })
        .catch((error) => {});
    },
    //表单提交
    submitForm(){
        // this.getTableListInit(); //添加後請求列表
        // this.dialogVisible = false;
        let listArr=[];
        let fileListarr = [];
        this.fileList.forEach(item => {
            if (typeof(item) == 'string') {
              fileListarr.push(item);
            } else {
              this.addOrganForm.checkup_item_case_image_list.forEach(element => {
                if(item.url == element.source) {
                  fileListarr.push(element.path)
                }
              });
            }
          });
        this.fileList = fileListarr;

        this.addOrganForm.evaluation_method_type_id_list.forEach(item=>{//根据评估方式选择数据
          if(parseInt(item)===1){
            listArr.push({
              evaluation_method_type_id:'1',
              checkup_item_inspection_point :this.addOrganForm.checkup_item_inspection_point1
            })
          }else if(parseInt(item)===2){
            listArr.push({
              evaluation_method_type_id:'2',
              checkup_item_inspection_point :this.addOrganForm.checkup_item_inspection_point2
            })
          }else if(parseInt(item)===3){
            listArr.push({
              evaluation_method_type_id:'3',
              checkup_item_inspection_point :this.addOrganForm.checkup_item_inspection_point3
            })
          }
        })
        //评估方式为0，支撑材料为1
        if(this.selectEntryInformation.checkup_item_evaluation_method_switch==='0'&&this.selectEntryInformation.checkup_item_inspection_point_switch==='1'){
          listArr=[{
            evaluation_method_type_id:'0',
            checkup_item_inspection_point :this.addOrganForm.checkup_item_inspection_point0
          }]
        }
          this.addOrganForm.checkup_category_id = this.addOrganForm.checkup_category_id[this.addOrganForm.checkup_category_id.length-1]
          this.addOrganForm.checkup_item_inspection_point_list=listArr;//对数组赋值
      let obj = {}
      obj.checkup_item_bcadd_bcsub = this.checkup_item_bcadd_bcsub
          obj.checkup_item_id = this.addOrganForm.checkup_item_id
          obj.checkup_item_name = this.addOrganForm.checkup_item_name
          obj.checkup_item_no = this.addOrganForm.checkup_item_no
          obj.checkup_category_id = this.addOrganForm.checkup_category_id
          obj.checkup_item_basic_score = this.addOrganForm.checkup_item_basic_score
          obj.checkup_item_evaluation_content = this.addOrganForm.checkup_item_evaluation_content
          obj.checkup_item_score_point = this.addOrganForm.checkup_item_score_point
          obj.checkup_item_standard_require = this.addOrganForm.checkup_item_standard_require
          obj.checkup_item_standard_point = this.addOrganForm.checkup_item_standard_point
          obj.checkup_item_review_method = this.addOrganForm.checkup_item_review_method
          obj.checkup_item_review_criteria_no_but = this.addOrganForm.checkup_item_review_criteria_no_but
          obj.checkup_item_review_criteria_deduction = this.addOrganForm.checkup_item_review_criteria_deduction
          obj.checkup_item_standard_review_number = this.addOrganForm.checkup_item_standard_review_number
          obj.checkup_item_standard_review_content = this.addOrganForm.checkup_item_standard_review_content
          obj.checkup_item_inspection_content = this.addOrganForm.checkup_item_inspection_content
          obj.checkup_item_inspection_basis = this.addOrganForm.checkup_item_inspection_basis
          obj.checkup_item_inspection_method = this.addOrganForm.checkup_item_inspection_method
          obj.checkup_item_case_image_list = this.fileList
          obj.checkup_item_complete_time_limit = this.addOrganForm.checkup_item_complete_time_limit
          obj.evaluation_method_type_id_list = []
          if(this.addOrganForm.evaluation_method_type_id_list){
            this.addOrganForm.evaluation_method_type_id_list.forEach(x=>{
              if(x != "0"){
                obj.evaluation_method_type_id_list.push(parseInt(x))
              }
            })
          }

          obj.checkup_item_inspection_point_list = []
          if(this.addOrganForm.checkup_item_inspection_point_list){
            this.addOrganForm.checkup_item_inspection_point_list.forEach(x=>{
              obj.checkup_item_inspection_point_list.push({
                evaluation_method_type_id:parseInt(x.evaluation_method_type_id),
                checkup_item_inspection_point:x.checkup_item_inspection_point
              })
            })
          }

          saveCheckupItemInfo(obj)
            .then((res) => {
              console.log(res);
              if (res.data.status === "1") {
                this.$message.success(res.data.msg);
                this.getTableListInit(); //添加後請求列表
                this.dialogVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }

            })
            .catch((error) => {
              this.dialogVisible = false;
              // this.$refs[formName].resetFields();
            });

    },

      resetForm() {
         this.dialogVisible = false;
      //重置表单
      this.addOrganForm= {
        checkup_item_id: "0",//检查条目id（0-添加;非0-修改）
        checkup_item_name: "",//检查条目名称
        checkup_item_no: "",//检查条目编号
        checkup_category_id: "",//检查分类id
        checkup_item_basic_score: "0",//标准分
        checkup_item_evaluation_content: "",//评估内容
        checkup_item_score_point: "",//评分标准
        checkup_item_standard_require: "",
        checkup_item_standard_point: "",
        checkup_item_review_method: "",
        checkup_item_review_criteria_no_but: "",
        checkup_item_review_criteria_deduction: "",
        checkup_item_standard_review_number : "",
        checkup_item_standard_review_content: "",
        checkup_item_inspection_content: "",
        checkup_item_inspection_basis: "",
        checkup_item_inspection_method: "",
        checkup_item_case_image_list: [],
        checkup_item_complete_time_limit:"",
        evaluation_method_type_id_list:[],//评估方式数组
        checkup_item_inspection_point_list:[],
        checkup_item_inspection_point1:"",//对应四项支撑材料，需要遍历evaluation_method_type_id_list数组放入checkup_item_inspection_point_list数组
        checkup_item_inspection_point2:"",
        checkup_item_inspection_point3:"",
        checkup_item_inspection_point0:"",
      } //机构添加的表单内容
      // this.$refs[formName].resetFields();
      this.selectEntryInformation={}
      console.log('clear sucess')
    },

       // 获取选中的数据
    handleSelectionChange(val) {
      console.log("下面打印的是选中的数据");
      console.log(val);
      this.multipleSelection = val;

    },
    // 表格中点击"删除"
    handleDelete(index, row) {
      this.$confirm('是否确定删除数据？', "提示").then(()=>{
        console.log("删除", index, row);
      let delArr=[]
      delArr.push(row.checkup_item_id)
      deleteCheckupItemInfo({
          checkup_item_id_list: delArr,
        })
        .then((res) => {
          console.log(res);
                  if(res.data.status==='1'){
            this.$message.success(res.data.msg);
          }else{
            this.$message.error(res.data.msg);
          }
          this.getTableListInit(); //刪除後請求列表
        })
        .catch((error) => {});
      })

    },
    getParentIds(parentId){
      let ids = []
      for(let i=0; i<this.classlistTree.length; i++){
        if(this._getParentIds(this.classlistTree[i], parentId, ids)){
          ids.unshift(this.classlistTree[i].checkup_category_id)
          break
        }
      }
      return ids
    },
    _getParentIds(data, parentId, ids){
      if(data.checkup_category_id == parentId){
        return true
      } else {
        for(let i=0; data.children && i<data.children.length; i++){
          if(this._getParentIds(data.children[i], parentId, ids)){
            ids.unshift(data.children[i].checkup_category_id)
            return true
          }
        }
      }
      return false
    },
    // 点击表格中"编辑"
    handleEdit(index, row) {
      console.log("编辑", index, row);
      getCheckupItemDetail({
        checkup_item_id:row.checkup_item_id
      }).then(res=>{
        if(res.data.status == "1"){
          this.fileList = [];

          let data = res.data.data.checkup_item_info
          console.log(JSON.stringify(data))
          this.dialogTitle = "编辑条目信息";
          this.dialogVisible = true;
          this.addOrganForm.checkup_item_id = data.checkup_item_id
          this.addOrganForm.checkup_item_name = data.checkup_item_name
          this.addOrganForm.checkup_item_no = data.checkup_item_no
          this.addOrganForm.checkup_category_id = this.getParentIds(data.checkup_category_info.checkup_category_id)
          this.addOrganForm.checkup_item_basic_score = data.checkup_item_basic_score_info.checkup_item_basic_score
          this.addOrganForm.checkup_item_evaluation_content = data.checkup_item_evaluation_content_info.checkup_item_evaluation_content
          this.addOrganForm.checkup_item_score_point = data.checkup_item_score_point_info.checkup_item_score_point

          this.addOrganForm.checkup_item_standard_require= data.checkup_item_standard_require_info.checkup_item_standard_require
          this.addOrganForm.checkup_item_standard_point= data.checkup_item_standard_point_info.checkup_item_standard_point
          this.addOrganForm.checkup_item_review_method= data.checkup_item_review_method_info.checkup_item_review_method
          this.addOrganForm.checkup_item_review_criteria_no_but= data.checkup_item_review_criteria_no_but_info.checkup_item_review_criteria_no_but
          this.addOrganForm.checkup_item_review_criteria_deduction= data.checkup_item_review_criteria_deduction_info.checkup_item_review_criteria_deduction
          this.addOrganForm.checkup_item_standard_review_number = data.checkup_item_standard_review_number_info.checkup_item_standard_review_number
          this.addOrganForm.checkup_item_standard_review_content= data.checkup_item_standard_review_content_info.checkup_item_standard_review_content
          this.addOrganForm.checkup_item_inspection_content= data.checkup_item_inspection_content_info.checkup_item_inspection_content
          this.addOrganForm.checkup_item_inspection_basis= data.checkup_item_inspection_basis_info.checkup_item_inspection_basis
          this.addOrganForm.checkup_item_inspection_method= data.checkup_item_inspection_method_info.checkup_item_inspection_method
          this.addOrganForm.checkup_item_case_image_list= data.checkup_item_case_image_info.checkup_item_case_image_list
          this.addOrganForm.checkup_item_complete_time_limit= data.checkup_item_complete_time_limit_info.checkup_item_complete_time_limit

          this.addOrganForm.checkup_item_case_image_list.forEach(item => {
            let obj = {
              name: '1',
              url: item.source
            }
            this.fileList.push(obj);
          })

          this.addOrganForm.evaluation_method_type_id_list = []
          if(data.checkup_item_inspection_point_info.checkup_item_inspection_point_list){
            data.checkup_item_inspection_point_info.checkup_item_inspection_point_list.forEach(x=>{
              this.addOrganForm.evaluation_method_type_id_list.push(x.evaluation_method_type_id)
            })
          }

          this.addOrganForm.checkup_item_inspection_point_list = []
          if(data.checkup_item_evaluation_method_info.checkup_item_inspection_point_list){
            data.checkup_item_evaluation_method_info.checkup_item_inspection_point_list.forEach(x=>{
              this.addOrganForm.checkup_item_inspection_point_list.push(x.evaluation_method_type_id)
            })
          }

          let inspection = data.checkup_item_inspection_point_info.checkup_item_inspection_point_list
          if(inspection){
            for(let i=0; i<inspection.length; i++){
              this.addOrganForm[
                `checkup_item_inspection_point${inspection[i].evaluation_method_type_id}`
              ] = inspection[i].checkup_item_inspection_point
            }
          }
          console.log(this.addOrganForm)
        }
      })
      /*
      this.dialogTitle = "编辑条目信息";
      this.dialogVisible = true;
      console.log(row.checkup_category_id)
      this.cascaderEntryInformation.forEach(item=>{
        if(item.checkup_category_id===row.checkup_category_id){
          this.selectEntryInformation=item
        }
      })
      let evaluation_method_type_id_list=[],checkup_item_inspection_point0,checkup_item_inspection_point1,checkup_item_inspection_point2,checkup_item_inspection_point3
      console.log(row.checkup_item_evaluation_origin_list)
      row.checkup_item_evaluation_origin_list.forEach(list=>{
        // let id=parseInt(list.evaluation_method_type_id)
        let id=list.evaluation_method_type_id
        evaluation_method_type_id_list.push(id)
        if(id==='0')checkup_item_inspection_point0=list.checkup_item_inspection_point
        else if(id==='1')checkup_item_inspection_point1=list.checkup_item_inspection_point
        else if(id==='2')checkup_item_inspection_point2=list.checkup_item_inspection_point
        else if(id==='3')checkup_item_inspection_point3=list.checkup_item_inspection_point

      })
      console.log(evaluation_method_type_id_list)
          row.evaluation_method_type_id_list=evaluation_method_type_id_list
          row.checkup_item_inspection_point0=checkup_item_inspection_point0
          row.checkup_item_inspection_point1=checkup_item_inspection_point1
          row.checkup_item_inspection_point2=checkup_item_inspection_point2
          row.checkup_item_inspection_point3=checkup_item_inspection_point3
      console.log(row.evaluation_method_type_id_list)
      this.addOrganForm = { ...row };
      this.evaluation_method_type_id_list=evaluation_method_type_id_list
      */
    },

    //添加分类
        addLine() {
      this.dialogVisible = true;
      this.dialogTitle = "添加条目信息";
    },

    // 批量删除
    deleteTable(){
      this.$confirm('是否确定删除数据？', "提示").then(()=>{
        // console.log(this.addOrganForm)
        let delArr=[]
      this.multipleSelection.forEach(item=>{
        delArr.push(parseInt(item.checkup_item_id))
      })
      if(delArr.length===0){
        this.$message.error('请选择要删除的数据')
        return
      }
      deleteCheckupItemInfo({
          checkup_item_id_list: delArr,
        })
        .then((res) => {
          console.log(res);
          // if(res.data.data.status==='1'){
            this.$message.success(res.data.msg);
          // }else{
            // this.$message.error(res.data.msg);
          // }

          this.getTableListInit(); //刪除後請求列表
        })
        .catch((error) => {});
      })

    },
    // 获取选择检查分类数据
    setCheckup(value){
      value = value[value.length-1]
      console.log(this.cascaderEntryInformation)
      this.cascaderEntryInformation.forEach(item=>{
        if(item.checkup_category_id===value){
          this.selectEntryInformation=item//设置选择分类数据
          //this.addOrganForm.checkup_item_name=item.checkup_category_name
         if(item.checkup_item_evaluation_content_switch==="0"){
           this.addOrganForm.checkup_item_evaluation_content=''
         }
          if(item.checkup_item_basic_score_switch==="0"){
           this.addOrganForm.checkup_item_basic_score=0
         }
          if(item.checkup_item_score_point_switch==="0"){
           this.addOrganForm.checkup_item_score_point=''
         }
          if(item.checkup_item_evaluation_method_switch==="0"&&item.checkup_item_inspection_point_switch==="0"){
           this.addOrganForm.checkup_item_evaluation_origin_list=[]
           this.addOrganForm.evaluation_method_type_id_list=[]
         }
          if(item.checkup_item_inspection_point_switch==="0"){
           this.addOrganForm.checkup_item_inspection_point0=''
         }

         if(item.checkup_item_name_switch==="0"){
           this.addOrganForm.checkup_item_name=''
         }

         if(item.checkup_item_standard_require_switch==="0"){
           this.addOrganForm.checkup_item_standard_require=''
         }

         if(item.checkup_item_standard_point_switch==="0"){
           this.addOrganForm.checkup_item_standard_point=''
         }

         if(item.checkup_item_review_method_switch==="0"){
           this.addOrganForm.checkup_item_review_method=''
         }

         if(item.checkup_item_review_criteria_no_but_switch==="0"){
           this.addOrganForm.checkup_item_review_criteria_no_but=''
         }

         if(item.checkup_item_review_criteria_deduction_switch==="0"){
           this.addOrganForm.checkup_item_review_criteria_deduction=''
         }

         if(item.checkup_item_standard_review_content_switch==="0"){
           this.addOrganForm.checkup_item_standard_review_content=''
         }

         if(item.checkup_item_standard_review_number_switch==="0"){
           this.addOrganForm.checkup_item_standard_review_number=''
         }

         if(item.checkup_item_inspection_content_switch==="0"){
           this.addOrganForm.checkup_item_inspection_content=''
         }

         if(item.checkup_item_inspection_basis_switch==="0"){
           this.addOrganForm.checkup_item_inspection_basis=''
         }

         if(item.checkup_item_inspection_method_switch==="0"){
           this.addOrganForm.checkup_item_inspection_method=''
         }

         if(item.checkup_item_case_image_switch==="0"){
           this.addOrganForm.checkup_item_case_image=''
         }

         if(item.checkup_item_complete_time_limit_switch==="0"){
           this.addOrganForm.checkup_item_complete_time_limit=''
         }
          this.scoreFlag = item.checkup_item_evaluation_deduct_point_switch

        }
      })

    },
    clearSelect(){
      this.selectEntryInformation={}
    }
  },
};
</script>
<style scoped>
#EntryInformation {
  position: relative;
}
.header {
  width: 100%;
  height: 35px !important;
  border-bottom: 1px solid #ccc;
}
.header-left {
  width: 200px;
  text-align: left;
  position: absolute;
}
.header-title {
  font-weight: bold;
  font-size: 18px;
}
.header-right {
  position: absolute;
  right: 20px;
  /* width: 55%; */
  height: 35px;
  top: -15px;
}
.el-form {
  display: flex;
  height: 35px;
}
.el-form-item {
  width: 180px;
  margin-right: 10px;
}
#EntryInformation >>> .el-input__inner {
  /* height: 35px; */
  padding: 0 10px;
  border: 1px solid #000;
}
#EntryInformation >>> .el-input input::-webkit-input-placeholder {
  color: #9e9fa3;
}
/* 表格样式修改 */
.el-table {
  color: #000;
}
#EntryInformation >>> .el-table thead {
  color: #000;
  font-weight: unset;
}
#EntryInformation >>> .el-table__header {
  width: 100%;
}
#EntryInformation >>> .el-table th.el-table__cell {
  background-color: #f3f3f3;
}
/* #EntryInformation >>> .el-table tr{

} */
#EntryInformation >>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  /* border-bottom: unset; */
}
.el-button--text {
  color: #000;
  font-size: 13px;
}
.el-table__row > td {
  /* border: none; */
}
.el-table::before {
  height: 0px;
}
#EntryInformation >>> .el-checkbox__inner {
  width: 16px;
  height: 16px;
  border: 1px solid #9e9fa3;
}
/* 对话框样式修改 */
#EntryInformation >>> .dialog .el-dialog__header {
  text-align: left;
}
#EntryInformation >>> .dialog .el-dialog__title {
  font-size: 20px;
}
#EntryInformation >>> .dialog .el-dialog__body {
  padding: 10px 20px;
  color: #000;
}
#EntryInformation >>> .dialog .el-dialog__body .el-form {
  width: 100%;
  height: 100%;
  display: block;
}
#EntryInformation >>> .dialog .el-dialog__body .el-form-item {
  width: 85%;
  margin-bottom: 15px;
}
.el-cascader {
  width: 100%;
}
.el-checkbox-group {
  float: left;
}
.textareaFrom {
  width: 94% !important;
}
#EntryInformation >>> .dialog .el-form-item__label {
  color: #000;
  font-size: 16px;
  text-align: left;
  line-height: 35px;
}
#EntryInformation >>> .dialog .el-input__inner {
  border: 1px solid #409eff;
  color: #000;
}
#EntryInformation >>> .dialog .el-textarea__inner {
  border: 1px solid #409eff;
  color: #000;
}

#EntryInformation >>> .dialog .el-select {
  width: 100%;
}
#EntryInformation >>> .dialog .el-dialog__footer {
  padding: 0px 20px 20px;
}
hr {
  border-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/backStage/children/EntryInformation/EntryInformation.vue